import React, { useEffect, useState } from 'react'

import BannerImg from '../../../../resources/img/Salar Banner.png'
import axios from 'axios'
import { decryptResponse } from '../../../../utils/customAxios'

const MobileBanners = () => {
	const [bannerImages, setBannerImages] = useState([])

	useEffect(() => {
		getCMS()
	}, [])

	const getCMS = async () => {
		const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get-cms`)
		if (process.env.REACT_APP_ENV === 'production') {
			if (response.status === 200) {
				if (response && response.data) {
					const decryptedResponse = decryptResponse(
						response.data,
						process.env.REACT_APP_RESPONSE_CRYPTO_HEX_KEY,
						process.env.REACT_APP_RESPONSE_CRYPTO_IV_KEY
					)
					response.data = decryptedResponse
					if (response.data.status === 1) {
						setBannerImages([])
						response.data.data?.mobileBannerImageUrls.map((img) => {
							setBannerImages((prev) => [...prev, `${process.env.REACT_APP_RESOURCE_URL}${img}`])
						})
					}
				}
			}
		} else if (response.data.status === 1) {
			setBannerImages([])
			response.data.data?.mobileBannerImageUrls.map((img) => {
				setBannerImages((prev) => [...prev, `${process.env.REACT_APP_RESOURCE_URL}${img}`])
			})
		}
	}
	return (
		<div>
			<div className='px-2'>
				<div className='d-flex justify-content-start gap-2 overflow-scroll align-items-center'>
					{bannerImages.length > 0 &&
						bannerImages.map((bannerImage, index) => (
							<div className='mb-0'>
								<a href=''>
									<div class='card text-center border-radius-2xl'>
										<img
											className='mini-deals-card'
											src={bannerImage}
											alt='Banner'
											// style={{
											// 	height: '17vh',
											// 	objectFit: 'cover',
											// 	borderRadius: '15px',
											// 	width: '100%',
											// }}
											onError={(e) => {
												e.target.onerror = null
												e.target.src = BannerImg
											}}
										/>
									</div>
								</a>
							</div>
						))}
				</div>
			</div>
		</div>
	)
}

export default MobileBanners
